import React from 'react';
import { Row, Col, Typography, Image } from 'antd';
import {
  FacebookOutlined,
  InstagramOutlined,
  YoutubeOutlined,
  LinkedinOutlined,
} from '@ant-design/icons'; 
import ISTLogo from '../Assets/Brand/ist-logo.png'; 
import HECLogo from '../Assets/Brand/hec.png'; 
import Uraan from '../Assets/Brand/uraan-pakistan.png'; 
import MinistryLogo from '../Assets/Brand/ministry-planning.png';
import '../Styles/HomeStyles.css';

const { Text, Title } = Typography;

const FooterComponent = () => {
  return (
    <footer className="footer-section">
      <Row gutter={[32, 32]} justify="space-between" align="middle">
        {/* Contact Info */}
        <Col xs={24} sm={24} md={8} lg={8} className="footer-col" align="center">
          <Title level={4} className="footer-title">
            Contact Info
          </Title>
          <Text className="footer-text">NCGSA Secretariat</Text>
          <Text className="footer-text">Institute of Space Technology</Text>
          <Text className="footer-text">1, Islamabad Highway, Islamabad 44000</Text>
          <a className="footer-text" href="tel:+92519075799">Phone: +92-51-9675799</a>
          <a className="footer-text" href="mailto:info@ncgsa.org.pk">Email: info@ncgsa.org.pk</a>
        </Col>

        {/* Social Media Links */}
        <Col xs={24} sm={24} md={8} className="footer-col" align="center">
          <Title level={4} className="footer-title">
            Get Social
          </Title>
          <div className="footer-social">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
              <FacebookOutlined className="social-icon fb" />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
              <InstagramOutlined className="social-icon insta" />
            </a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
              <YoutubeOutlined className="social-icon yt" />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
              <LinkedinOutlined className="social-icon linkedin" />
            </a>
          </div>
        </Col>

        {/* Logos */}
        <Col xs={24} sm={24} md={8} className="footer-col logos-col" align="center">
          <a className="footer-logo-link" href="https://www.pc.gov.pk/" target="_blank" rel="noopener noreferrer" aria-label="Planning Commission of Pakistan">
            <Image preview={false} src={MinistryLogo} alt="Ministry of Planning Commission" className="footer-logo footer-logo--ministry" />
          </a>
          <a className="footer-logo-link" href="https://uraanpakistan.pk/" target="_blank" rel="noopener noreferrer" aria-label="Uraan Pakistan">
            <Image preview={false} src={Uraan} alt="Uraan Pakistan" className="footer-logo footer-logo--uraan" />
          </a>
          <a className="footer-logo-link" href="https://www.hec.gov.pk/english/Pages/default.aspx" target="_blank" rel="noopener noreferrer" aria-label="Higher Education Commission">
            <Image preview={false} src={HECLogo} alt="Higher Education Commission" className="footer-logo footer-logo--hec" />
          </a>
          <a className="footer-logo-link" href="https://ist.edu.pk/" target="_blank" rel="noopener noreferrer" aria-label="Institute of Space Technology">
            <Image preview={false} src={ISTLogo} alt="Institute of Space Technology" className="footer-logo footer-logo--ist" />
          </a>
        </Col>
      </Row>
    </footer>
  );
};

export default FooterComponent;
